import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgEnvelope = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-envelope';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M3.258 3.29c-.01.027-.014 3.965-.008 8.75l.01 8.7 8.75.01 8.75.01V3.24h-8.741c-6.956 0-8.745.01-8.761.05m15.98 2.9-.002 1.43-3.62 2.485-3.62 2.485-3.617-2.485L4.762 7.62l-.001-1.43-.001-1.43h14.48zM6.977 10.959c.592.408 1.082.759 1.09.781.007.022-.734.787-1.647 1.7L4.76 15.1V9.435l.57.392zm12.254 2.724-.011 1.397-1.67-1.67-1.671-1.671 1.671-1.147 1.67-1.148.011 1.421c.005.782.005 2.05 0 2.818m-8.541-.167c.677.466 1.253.855 1.28.865s.635-.386 1.35-.879l1.3-.898 2.31 2.308 2.31 2.308v2.02H4.76v-2.02l2.308-2.308c1.424-1.424 2.324-2.296 2.35-2.276.023.018.596.414 1.272.88"
    })
  }));
});
export default SvgEnvelope;